var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.262 0.156967L12.3853 1.03352C12.1729 1.2458 12.1764 1.59108 12.393 1.79903L15.9987 5.2612H0.597086C0.301052 5.2612 0.0610352 5.50117 0.0610352 5.79715V7.0477C0.0610352 7.34368 0.301052 7.58365 0.597086 7.58365H15.9987L12.393 11.0458C12.1764 11.2538 12.1729 11.5991 12.3853 11.8113L13.262 12.6879C13.4713 12.8972 13.8107 12.8972 14.0201 12.6879L19.9077 6.80139C20.117 6.5921 20.117 6.25275 19.9077 6.04342L14.02 0.156967C13.8107 -0.0523223 13.4713 -0.0523223 13.262 0.156967Z","fill":"#F3F7F9"}));
}

ArrowInline.defaultProps = {"width":"21","height":"13","viewBox":"0 0 21 13","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
